if (!customElements.get('fc-feeding-system-v2')) {
  class FcFeedingSystemV2 extends TabsComponent {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.handleTabChange = this.handleTabChange.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleTabLinkClick = this.handleTabLinkClick.bind(this);
      this.handleSwipeStart = this.handleSwipeStart.bind(this);
      this.handleSwipeMove = this.handleSwipeMove.bind(this);
      this.handleSwipeEnd = this.handleSwipeEnd.bind(this);
      this.handleSwipeCancel = this.handleSwipeCancel.bind(this);
      this.mobileQuery = window.matchMedia('(max-width: 767.98px)');
      this.swipe = null;
      this.addEventListener('tabChange', this.handleTabChange);
      this.addEventListener('click', this.handleTabLinkClick);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    connectedCallback() {
      super.connectedCallback();
      this.syncFeatureGroups(this.selectedIndex || 0);
      this.addSwipeListeners();
    }

    disconnectedCallback() {
      this.removeEventListener('tabChange', this.handleTabChange);
      this.removeEventListener('click', this.handleTabLinkClick);
      this.removeSwipeListeners();

      if (window.Shopify && Shopify.designMode) {
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    get featureGroups() {
      return Array.from(this.querySelectorAll('[data-fc-feature-group]'));
    }

    get productLayer() {
      return this.querySelector('[data-fc-product-layer]');
    }

    addSwipeListeners() {
      if (!this.productLayer) return;

      this.productLayer.addEventListener('pointerdown', this.handleSwipeStart);
      this.productLayer.addEventListener('pointermove', this.handleSwipeMove);
      this.productLayer.addEventListener('pointerup', this.handleSwipeEnd);
      this.productLayer.addEventListener('pointercancel', this.handleSwipeCancel);
      this.productLayer.addEventListener('pointerleave', this.handleSwipeCancel);
    }

    removeSwipeListeners() {
      if (!this.productLayer) return;

      this.productLayer.removeEventListener('pointerdown', this.handleSwipeStart);
      this.productLayer.removeEventListener('pointermove', this.handleSwipeMove);
      this.productLayer.removeEventListener('pointerup', this.handleSwipeEnd);
      this.productLayer.removeEventListener('pointercancel', this.handleSwipeCancel);
      this.productLayer.removeEventListener('pointerleave', this.handleSwipeCancel);
    }

    handleTabChange(event) {
      this.syncFeatureGroups(event.detail.selectedIndex || 0);
    }

    handleBlockSelect(event) {
      if (event.detail.sectionId !== this.sectionId) return;
      const index = Number(event.target.dataset.index);
      if (Number.isNaN(index)) return;

      this.setActiveTab(index);
    }

    handleTabLinkClick(event) {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest('[data-fc-tab-link]');
      if (!trigger || !this.contains(trigger)) return;

      const link = trigger.dataset.fcTabLink;
      if (!link || (window.Shopify && Shopify.designMode)) return;

      window.location.href = link;
    }

    handleSwipeStart(event) {
      if (!this.mobileQuery.matches || this.buttons.length < 2 || event.pointerType === 'mouse') return;

      this.swipe = {
        id: event.pointerId,
        startX: event.clientX,
        startY: event.clientY,
        deltaX: 0,
        deltaY: 0,
        target: event.currentTarget
      };

      if (event.currentTarget.setPointerCapture) {
        event.currentTarget.setPointerCapture(event.pointerId);
      }
    }

    handleSwipeMove(event) {
      if (!this.swipe || event.pointerId !== this.swipe.id) return;

      this.swipe.deltaX = event.clientX - this.swipe.startX;
      this.swipe.deltaY = event.clientY - this.swipe.startY;
    }

    handleSwipeEnd(event) {
      if (!this.swipe || event.pointerId !== this.swipe.id) return;

      const { deltaX, deltaY } = this.swipe;
      this.releaseSwipeCapture(event);
      this.swipe = null;

      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY) * 1.25) return;

      const direction = deltaX < 0 ? 1 : -1;
      const nextIndex = (this.selectedIndex + direction + this.buttons.length) % this.buttons.length;
      this.setActiveTab(nextIndex);
    }

    handleSwipeCancel(event) {
      if (!this.swipe || event.pointerId !== this.swipe.id) return;

      this.releaseSwipeCapture(event);
      this.swipe = null;
    }

    releaseSwipeCapture(event) {
      if (!this.swipe.target || !this.swipe.target.releasePointerCapture) return;
      if (!this.swipe.target.hasPointerCapture || !this.swipe.target.hasPointerCapture(event.pointerId)) return;

      this.swipe.target.releasePointerCapture(event.pointerId);
    }

    syncFeatureGroups(index) {
      this.featureGroups.forEach((group) => {
        const active = Number(group.dataset.index) === Number(index);
        group.hidden = !active;
        group.classList.toggle('is-active', active);
      });
    }
  }

  customElements.define('fc-feeding-system-v2', FcFeedingSystemV2);
}
